import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import "../../../../components/table.css";
import ViewImg from "../../../../image/View.svg";
import EditImg from "../../../../image/Edit.svg";
import CreateSIImg from "../../../../image/createBl.svg";
import Pagination from "../../../../components/Pagination";
import BackButton from "../../../../components/BackButton";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";

const ListofBookingsAdmin = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(bookings, 5);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await api.get("/booking/admin-booking-list");
        console.log("response", response);

        setBookings(
          Array.isArray(response.data.bookings) ? response.data.bookings : []
        );
      } catch (error) {
        console.error("Failed to fetch bookings:", error);
        setBookings([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

 
  
  const columns = [
    { label: "Booking No.", accessor: "booking_id" },
    {
      label: "Company Name",
      accessor: "client_company",
    },
    { label: "POL", accessor: "pol" },
    { label: "POD", accessor: "pod" },
    { label: "Status", accessor: "Status_client" || "QuotationAccepted" },
    {
      label: "Action",
      render: (row) => (
        <>
          <Link to={`/my-bookings/view-bookings/admin/${row.enq_id}`}>
            <img src={ViewImg} alt="View" />
          </Link>
          <Link to={`/my-bookings/edit-bookings/admin/${row.enq_id}`} className="ms-2">
            <img src={EditImg} alt="Edit" />
          </Link>
          {row.Status_client === "Quotation Accepted" && (
            <Link to={`/my-bookings/create-shipping-instructions/${row.enq_id}`} className="ms-2" title="Create Shipping Instructions">
              <img src={CreateSIImg} alt="Create SI" style={{ width: "20px", height: "20px" }} />
            </Link>
          )}
        </>
      ),
    },
  ];
  return (
    <>
      <BackButton />

      {loading ? (
        <p>Loading bookings...</p>
      ) : (
        <>
          <Table
            columns={columns}
            data={currentItems}
            loading={loading}
            emptyMessage="No enquiries found."
              itemsPerPage={itemsPerPage}
            pagination={
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={goToPage}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                totalItems={totalItems}
              />
            }
          />
        </>
      )}
    </>
  );
};
export default ListofBookingsAdmin;